
  export default {
    components: {},
    props: {
      categoryLink: {
        type: String,
        default: "#",
      },

      categoryName: {
        type: String,
        default: "Category Name",
      },
      icon: {
        type: String,
        default: "",
      }
    },
  };

